import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GoogleCallbackHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const isNewUser = params.get('isNewUser') === 'true';
    const error = params.get('error');

    if (!token && !error) {
      // Avoid unnecessary logs when re-rendered
      return;
    }

    console.log('Callback params:', { token, isNewUser, error });

    if (token) {
      localStorage.setItem('token', decodeURIComponent(token));
      console.log('Google login token saved:', decodeURIComponent(token));

      // Optional: show toast or alert here
      if (isNewUser) {
        navigate('/auth/google/address', { state: { fromGoogle: true } });
      } else {
        navigate('/');
      }
    } else {
      console.error('Google login failed:', error || 'No token received');
      navigate(`/login?error=auth_failed${error ? `&message=${encodeURIComponent(error)}` : ''}`);
    }
  }, [navigate]);

  return <div>Logging in with Google...</div>;
};

export default GoogleCallbackHandler;
